import { createContext, useContext, useReducer } from 'react';
import { branchCodeReducer, initialState } from './reducer';

const BranchCodeContext = createContext();

export const BranchCodeProvider = ({ children }) => {
    const [state, dispatch] = useReducer(branchCodeReducer, initialState);

    return <BranchCodeContext.Provider value={[state, dispatch]}>{children}</BranchCodeContext.Provider>;
};

export const useBranchCodeContext = () => {
    const context = useContext(BranchCodeContext);
    if (!context) {
        throw new Error('useBranchCodeContext must be used within a BranchCodeProvider');
    }
    return context;
};
